var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-default',{attrs:{"show-backpack":false,"show-promo-message":false}},[_c('NewHome')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }